import { useState } from "react";

import { Link, useNavigate } from "react-router-dom";

import { useSetRecoilState } from "recoil";
import { profileState, signInState, getToken, userType } from "lib/store/user";
import { errorToastState } from "lib/store/common";

import {
  Button,
  Input,
  Checkbox,
  TextDivider,
  Hr,
  ButtonLike,
} from "@atsent/components";

import { GoogleSignIn } from "components/atom/GoogleSignIn";
import { HeaderNFooter } from "components/template/HeaderNFooter";
import { Spinner } from "components/atom/Spinner";

import "./SignInPage.scss";

type UserProps = {
  access_token: string;
  refresh_token: string;
  user: userType;
};

const imageF = process.env.PUBLIC_URL + "/static-image";

export const SignInPage = () => {
  const setLogged = useSetRecoilState(signInState);
  const setErrorToast = useSetRecoilState(errorToastState);
  const setUser = useSetRecoilState(profileState);
  const navigate = useNavigate();
  const [input, setInput] = useState({
    username: "",
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);

  const handleSignIn = async () => {
    await setLoading(true);
    try {
      const param = {
        ...input,
        email: localStorage.getItem("userid") || input.email,
      };
      const { access_token, refresh_token, user }: UserProps = await getToken(
        param
      );
      localStorage.setItem("token", access_token);
      localStorage.setItem("refToken", refresh_token);
      await setUser(user);
      await setLogged(true);
      await navigate("/");
    } catch (e) {
      setErrorToast(e);
    }
    await setLoading(false);
  };

  return (
    <HeaderNFooter cx={"SignInPage"}>
      <section>
        <div className="left">
          <picture>
            <source
              srcSet={`${imageF}/signin_image.webp 1x,${imageF}/signin_image@2x.webp 2x,${imageF}/signin_image@3x.webp 3x`}
              type="image/webp"
            />
            <source
              srcSet={`${imageF}/signin_image.png 1x,${imageF}/signin_image@2x.png 2x,${imageF}/signin_image@3x.png 3x`}
              type="image/png"
            />
            <img src={imageF + "/signin_image.png"} alt="man" />
          </picture>
        </div>
        <div className="right">
          <div className="wrapper">
            <span className={"title"}>로그인</span>
            <Input
              label={"이메일"}
              placeholder={"이메일"}
              inputValue={localStorage.getItem("userid")}
              handleOnChange={(e: any) => {
                setInput((input) => ({ ...input, email: e.target.value }));
                if (!!localStorage.getItem("userid")) {
                  localStorage.setItem("userid", e.target.value);
                }
              }}
              removable
            />
            <Input
              label={"비밀번호"}
              type={"password"}
              placeholder={"비밀번호"}
              handleOnChange={(e: any) =>
                setInput((input) => ({ ...input, password: e.target.value }))
              }
              removable
            />

            {loading ? (
              <ButtonLike>
                <Spinner bgColor={"black"} />
              </ButtonLike>
            ) : (
              <Button click={async () => await handleSignIn()}>로그인</Button>
            )}
            <Checkbox
              label={"아이디 저장"}
              defaultChecked={!!localStorage.getItem("userid")}
              onChange={(e: any) => {
                if (e.target.checked) {
                  localStorage.setItem("userid", input.email);
                } else {
                  localStorage.removeItem("userid");
                }
              }}
            />
            <TextDivider text={"Or"} />
            <GoogleSignIn />
            <Hr />
            <Link to={"#"}>{/*계정/비밀번호 찾기*/}</Link>
            <Link to={"/sign-up"}>회원가입</Link>
          </div>
        </div>
      </section>
    </HeaderNFooter>
  );
};
